import request from '@/utils/request';

// 预警系统列表
export function warningListApi(data) {
  return request({
    url: '/admin/alert_system',
    method: 'get',
    params: data,
  });
}

// 预警系统-添加
export function warningAddApi(data) {
  return request({
    url: '/admin/alert_system',
    method: 'post',
    data,
  });
}

// 预警系统查看
export function warningViewApi(data) {
  return request({
    url: '/admin/alert_system/' + data.id,
    method: 'get',
    params: data,
  });
}

// 预警系统-修改
export function warningFixApi(data) {
  return request({
    url: '/admin/alert_system/' + data.id,
    method: 'put',
    data,
  });
}

// 预警系统-删除
export function warningDeleteApi(data) {
  return request({
    url: '/admin/alert_system/' + data.id,
    method: 'delete',
    data,
  });
}

// 预警系统-切换开关
export function warningSwitchApi(data) {
  return request({
    url: '/admin/switch_alert_system_status/' + data.id,
    method: 'put',
    data,
  });
}

// 预警系统-获取下拉框
export function getSelectListApi() {
  return request({
    url: '/admin/get_alert_system_select',
    method: 'get',
  });
}

// 预警系统-批量处理预警
export function manageWarninApi(data) {
  return request({
    url: '/admin/batch_deal_alert_system',
    method: 'put',
    data,
  });
}

// 预警系统-匹配预警通知人
export function matchAlertAdmin(params) {
  return request({
    url: '/admin/match_alert_admin',
    method: 'get',
    params: params,
  });
}
